import React from 'react'

import Panel, { PanelLevel } from '@cinch/oxd-components/panel/src'
import { Text, TextStyles } from '@cinch-labs/design-system'
import BaseButton from '@cinch/oxd-components/button/src/base'
import { BaseButtonProps } from '@cinch/oxd-components/button/src/base/base-button.component'

import * as styles from './valuation-panel.module.css'

interface ValuationPanelProps {
  value: string
  i18n: {
    title: string
    transactionFee: string
    ctaText: string
  }
  level?: PanelLevel
  onChanges: (event: any) => void
}

const ValuationPanel: React.FC<ValuationPanelProps> = ({
  value,
  i18n = { title: '', transactionFee: '', ctaText: '' },
  level = PanelLevel.mid,
  onChanges,
}) => (
  <Panel className={styles.panel} level={level}>
    <Text oxford={true} element="h3" type={TextStyles.cardTitle}>
      {i18n.title}
    </Text>
    <Text className={styles.price} type={TextStyles.vehiclePrice}>
      {value}
    </Text>
    <Text oxford={true} className={styles.transactionFee} type={TextStyles.body2}>
      {i18n.transactionFee}
    </Text>
    <EditButton onClick={onChanges}>{i18n.ctaText}</EditButton>
  </Panel>
)

export const EditButton: React.FC<BaseButtonProps> = ({ children, ...props }) => (
  <BaseButton className={styles.button} {...props}>
    {children}
  </BaseButton>
)

export default ValuationPanel
